<template>
  <div>
    <TemplatesTable></TemplatesTable>
  </div>
</template>

<script>
import TemplatesTable from 'CORE/components/project/template/table'

export default {
    name: 'TemplatesView',
    components: {
        TemplatesTable,
    },
}
</script>
